import React from 'react';

const HomeSlider = ({ hero_banners, app_site_storage_path }) => {
    return (
        <div id="shopify-section-1586608150816" className="shopify-section index-section index-section--flush">
            <div className="holder fullwidth fullboxed mt-0 full-nopad">
                <div className="container">
                    <div className="bnslider-wrapper">
                        <div className="bnslider keep-scale" data-start-width={1920} data-start-height={785} data-start-mwidth={414} data-start-mheight={736} id="bnslider-1586608150816" data-autoplay="true" data-speed={5000}>
                            {hero_banners.map((el, index) => (
                                <a href="#" target="_self" className="bnslider-slide" key={index}>
                                    <div className="bnslider-image-mobile lazyload fade-up-fast" data-bgset={`${app_site_storage_path}${el.image}`} data-sizes="auto" />
                                    <div className="bnslider-image lazyload fade-up-fast" data-bgset={`${app_site_storage_path}${el.image}`} data-sizes="auto" />
                                </a>
                            ))}
                        </div>
                        <div className="bnslider-loader" />
                        <div className="bnslider-arrows d-sm-none container"><div /></div>
                        <div className="bnslider-dots d-none d-sm-block container" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeSlider;
